"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var startOfDay = require("date-fns/start_of_day");
var startOfMonth = require("date-fns/start_of_month");
var endOfDay = require("date-fns/end_of_day");
var endOfMonth = require("date-fns/end_of_month");
var subSeconds = require("date-fns/sub_seconds");
var subMonths = require("date-fns/sub_months");
var addSeconds = require("date-fns/add_seconds");
var addMonths = require("date-fns/add_months");
var isWithinRange = require("date-fns/is_within_range");
var isBefore = require("date-fns/is_before");
var isAfter = require("date-fns/is_after");
var min = require("date-fns/min");
var max = require("date-fns/max");
var isSameDay = require("date-fns/is_same_day");
function isDayInRange(day, startDate, endDate) {
    var normalizedDay = startOfDay(day);
    var before = subSeconds(startOfDay(startDate), 1);
    var after = addSeconds(startOfDay(endDate), 1);
    return isBefore(before, after) && isWithinRange(normalizedDay, before, after);
}
exports.isDayInRange = isDayInRange;
function isDayDisabled(day, _a) {
    var _b = _a === void 0 ? {} : _a, minDate = _b.minDate, maxDate = _b.maxDate, excludeDates = _b.excludeDates, includeDates = _b.includeDates, filterDate = _b.filterDate;
    return ((minDate && isBefore(day, startOfDay(minDate))) ||
        (maxDate && isAfter(day, endOfDay(maxDate))) ||
        (excludeDates &&
            excludeDates.some(function (excludeDate) { return isSameDay(day, excludeDate); })) ||
        (includeDates &&
            !includeDates.some(function (includeDate) { return isSameDay(day, includeDate); })) ||
        (filterDate && !filterDate(day)) ||
        false);
}
exports.isDayDisabled = isDayDisabled;
function allDaysDisabledBeforeMonth(day, _a) {
    var _b = _a === void 0 ? {} : _a, minDate = _b.minDate, includeDates = _b.includeDates;
    var dateBefore = subMonths(day, 1);
    return ((minDate && isBefore(dateBefore, startOfMonth(minDate))) ||
        (includeDates &&
            includeDates.every(function (includeDate) {
                return isBefore(dateBefore, startOfMonth(includeDate));
            })) ||
        false);
}
exports.allDaysDisabledBeforeMonth = allDaysDisabledBeforeMonth;
function allDaysDisabledAfterMonth(day, _a) {
    var _b = _a === void 0 ? {} : _a, maxDate = _b.maxDate, includeDates = _b.includeDates;
    var dateAfter = addMonths(day, 1);
    return ((maxDate && isAfter(dateAfter, endOfMonth(maxDate))) ||
        (includeDates &&
            includeDates.every(function (includeDate) {
                return isAfter(dateAfter, endOfMonth(includeDate));
            })) ||
        false);
}
exports.allDaysDisabledAfterMonth = allDaysDisabledAfterMonth;
function getEffectiveMinDate(_a) {
    var minDate = _a.minDate, includeDates = _a.includeDates;
    if (includeDates && minDate) {
        return min.apply(undefined, includeDates.filter(function (includeDate) {
            return isSameDay(minDate, includeDate) || isBefore(minDate, includeDate);
        }));
    }
    else if (includeDates) {
        return min.apply(undefined, includeDates);
    }
    else {
        return minDate;
    }
}
exports.getEffectiveMinDate = getEffectiveMinDate;
function getEffectiveMaxDate(_a) {
    var maxDate = _a.maxDate, includeDates = _a.includeDates;
    if (includeDates && maxDate) {
        return max.apply(undefined, includeDates.filter(function (includeDate) {
            return isSameDay(maxDate, includeDate) || isAfter(maxDate, includeDate);
        }));
    }
    else if (includeDates) {
        return max.apply(undefined, includeDates);
    }
    else {
        return maxDate;
    }
}
exports.getEffectiveMaxDate = getEffectiveMaxDate;
//# sourceMappingURL=date_utils.js.map
